// src/services/api/analytics.js
import apiClient from "./config";

/**
 * Fetches platform-wide analytics: top topics, student counts, quiz activity,
 * and reviewer creation trend. Available to all logged-in students.
 */
export const getPlatformAnalytics = async () => {
  try {
    const response = await apiClient.get("/analytics/platform");
    return response.data; // { success, data: { topTopics, creationTrend, summary } }
  } catch (error) {
    console.error("Failed to fetch platform analytics", error);
    return null;
  }
};
